import { Spinner, SpinnerSize } from '@fluentui/react';
import { useCallback } from 'react';
import styled from 'styled-components';
import { CenterContentDiv, HintText } from '../styled-components';

const Container = styled(CenterContentDiv)`
  padding: 0.25rem;
`;

function useDetailsListNoItemsTextRenderer(count: number, isLoading?: boolean, itemsName?: string) {
    const onRenderDetailsFooter = useCallback(
        () => {
            if (isLoading)
                return (
                    <Container>
                        <Spinner size={SpinnerSize.small} label="Loading..." labelPosition="right"></Spinner>
                    </Container>
                );

            if (count === 0)
                return (
                    <Container>
                        <HintText italic>{itemsName ? `No ${itemsName} to show` : 'Nothing to show'}</HintText>
                    </Container>
                );

            return <div />;
        },
        [count, isLoading, itemsName],
    );

    return onRenderDetailsFooter;
}

export default useDetailsListNoItemsTextRenderer;